"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.button.start': 'Start onboarding',
    'onboarding.button.continue': 'Continue',
    'onboarding.button.previous': 'Previous',
    'onboarding.button.next': 'Next',
    'onboarding.button.complete': 'Complete',
};
